export const groupBy = <T extends Record<string, string>>(initialArray: T[], key: string): Record<string, T[]> => {
    return initialArray.reduce((accumulator, current) => {
        const groupedKey = current[key];
        if (!accumulator[groupedKey]) {
            accumulator[groupedKey] = [];
        }
        accumulator[groupedKey].push(current);
        return accumulator;
    }, {} as Record<string, T[]>);
};
